import { render, staticRenderFns } from "./ProductivityReporting.vue?vue&type=template&id=43c3b589"
import script from "./ProductivityReporting.vue?vue&type=script&lang=js"
export * from "./ProductivityReporting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports